module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/94.bd28e3dd.png";